var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowControls)?_c('div',[_c('iframe',{attrs:{"src":_vm.youtubeUrl,"frameborder":"0","allowfullscreen":""}})]):_c('img',{attrs:{"src":_vm.videoImage,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }